import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  NextOrPreviousPayload,
  OpenModalPayload,
  ProductMediaState,
  SetCurrentMediaPayload,
} from 'src/components/organisms/ProductMediaCarousel/types';

export const initialState: Readonly<ProductMediaState> = {
  navigatedBy: null,
  currentMedia: 0,
  isModalOpen: false,
};

export const { actions, reducer } = createSlice({
  name: 'productMediaCarousel',
  initialState,
  reducers: {
    nextMedia: (state, { payload }: PayloadAction<NextOrPreviousPayload>) => {
      state.currentMedia =
        state.currentMedia === payload.totalMedia - 1 ? 0 : state.currentMedia + 1;
      state.navigatedBy = 'click';
    },
    prevMedia: (state, { payload }: PayloadAction<NextOrPreviousPayload>) => {
      state.currentMedia =
        state.currentMedia === 0 ? payload.totalMedia - 1 : state.currentMedia - 1;
      state.navigatedBy = 'click';
    },
    setCurrentMedia: (state, action: PayloadAction<SetCurrentMediaPayload>) => {
      state.currentMedia = action.payload.mediaIndex;
      state.navigatedBy = action.payload.navigationType;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
    openModal: (state, _action: PayloadAction<OpenModalPayload>) => {
      state.isModalOpen = true;
    },
  },
});
